<template>
  <div class="w-full md:flex md:justify-center py-4 md:py-8">
    <section class="w-full max-w-7xl mx-auto px-5 py-2 md:p-4 lg:p-0">
      <div class="flex flex-col gap-5">
        <h2
          class="hidden md:block md:text-[35px] text-[#1f1f1f] font-semibold text-center"
        >
          Hiring Corporates
        </h2>
        <p class="text-[18px] font-normal mt-[-20px]">Our learners are working in top MNCs, and so will you.</p>
        <h2
          class="block md:hidden text-[24px] text-[#1f1f1f] font-semibold text-left"
        >
          Hiring Corporates
        </h2>
        <p class="block md:hidden text-[14px] text-left font-normal mt-[-15px]">Our learners are working in top MNCs, and so will you.</p>
        <div>
          <div class="w-full">
            <div class="slick_elective">
              <template v-for="partner in company_partners" :key="partner">
                <div class="min-h-[100px] cursor-pointer">
                  <img
                    :src="partner.image"
                    alt=""
                    class="w-[152px] bg-white object-contain mx-auto rounded-lg shadow-xl"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import 'slick-carousel'
export default {
  name: 'FirmsTrust',
  data() {
    return {
      company_partners: [
        {
          image: require('@/assets/electiveListing/company/kellogs.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/johnson.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/infosys.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/icici.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/honeywell.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/hitachi.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/hector.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/hdfc.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/google.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/flipkart.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/facebook.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/ey.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/standard.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/pwc.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/mtr.webp'),
        },
        {
          image: require('@/assets/electiveListing/company/kpmg.webp'),
        },
      ],
    }
  },
  mounted() {
    $(`.slick_elective`).slick({
      infinite: true,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    })
  },
}
</script>

<style></style>
